import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  readonly authApi: string;
  readonly pessoaApi: string;
  readonly enderecoApi: string;
  readonly veiculoApi: string;
  readonly workflowApi: string;
  readonly bilhetagemApi: string;
  private readonly baseApiPath = environment.baseApiPath;
  private readonly localApiPath = 'http://localhost';

  constructor() {
    if (environment.environment === 'local') {
      // Local
      this.authApi = `${this.localApiPath}:8083`;
      this.pessoaApi = `${this.localApiPath}:8082`;
      this.enderecoApi = `${this.localApiPath}:8086`;
      this.veiculoApi = `${this.localApiPath}:8087`;
      this.workflowApi = `${this.localApiPath}:8088`;
      this.bilhetagemApi = `${this.localApiPath}:8089`;
    } else if (environment.environment === 'prod') {
      // Prod
      this.authApi = `${this.baseApiPath}/api/token`;
      this.pessoaApi = `${this.baseApiPath}/api/pessoa`;
      this.enderecoApi = `${this.baseApiPath}/api/endereco`;
      this.veiculoApi = `${this.baseApiPath}/api/veiculo`;
      this.workflowApi = `${this.baseApiPath}/api/workflow`;
      this.bilhetagemApi = `${this.baseApiPath}/api/bilhetagem`;
    } else {
      // Dev, TST, HML...
      this.authApi = `${this.baseApiPath}/${environment.environment}/transporte/sgtp/api/token`;
      this.pessoaApi = `${this.baseApiPath}/${environment.environment}/transporte/sgtp/api/pessoa`;
      this.enderecoApi = `${this.baseApiPath}/${environment.environment}/transporte/sgtp/api/endereco`;
      this.veiculoApi = `${this.baseApiPath}/${environment.environment}/transporte/sgtp/api/veiculo`;
      this.workflowApi = `${this.baseApiPath}/${environment.environment}/transporte/sgtp/api/workflow`;
      this.bilhetagemApi = `${this.baseApiPath}/${environment.environment}/transporte/sgtp/api/bilhetagem`;
    }

    // Teste local com mock (ex.: Mockoon do PBI 110690): `veiculoApiUrl` no
    // environment.local.ts aponta só a veiculo-api para outro host. Ausente nos
    // demais environments, então não tem efeito fora do teste local.
    const veiculoApiUrl = (environment as Record<string, unknown>)[
      'veiculoApiUrl'
    ];
    if (typeof veiculoApiUrl === 'string' && veiculoApiUrl) {
      this.veiculoApi = veiculoApiUrl;
    }
  }
}
